import BaseEnum from "./base_enum.js";

class ProjectPublishedFilterModeEnumDesc extends BaseEnum {

  name() {
    return "project_published_filter_mode";
  }

  rawValues() {
    return ["true", "false"];
  }

}

const ProjectPublishedFilterModeEnum = new ProjectPublishedFilterModeEnumDesc();
export default ProjectPublishedFilterModeEnum;